import { createRoot } from "react-dom/client";
import {CreateAccount} from "./CreateAccount";

const createAccountContainer = document.getElementById("monad-account");
if (createAccountContainer) {
    const createAccountRoot = createRoot(createAccountContainer)
    createAccountRoot.render(<CreateAccount nonce={createAccountContainer.dataset.nonce}/>);
}
